export default __webpack_public_path__ + "static/media/FilterTriangle.fd8fbfb9.svg";